export const strSEOClear = (str) => {
    if (!str) return str;
    try {
        str = str.replaceAll(/\\/g, "");
        str = str.replaceAll("\"", "");
        return str;
    } catch(err) {
        return str;
    }
}
